import { render, staticRenderFns } from "./OsCustomerApiKey.vue?vue&type=template&id=0f587873&scoped=true"
import script from "./OsCustomerApiKey.vue?vue&type=script&lang=ts"
export * from "./OsCustomerApiKey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f587873",
  null
  
)

export default component.exports